import { type DashRouteType, URL_APP_ADMIN } from '@retailer-platform/dashboard/routing'

// Enterprise Status Page Routes
const URL_APP_ADMIN_ENTERPRISE_STATUS_PAGE = `${URL_APP_ADMIN}/enterprise-status-page`
const URL_APP_ADMIN_ENTERPRISE_STATUS_PAGE_CREATE_INCIDENT = `${URL_APP_ADMIN_ENTERPRISE_STATUS_PAGE}/create-incident`

// @hygen:inject scoped-urls

export type DashRouteSet = DashRouteType<
  'app-admin-enterprise-status-page' | 'app-admin-enterprise-status-page-create-incident'
>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  'app-admin-enterprise-status-page': URL_APP_ADMIN_ENTERPRISE_STATUS_PAGE,
  'app-admin-enterprise-status-page-create-incident':
    URL_APP_ADMIN_ENTERPRISE_STATUS_PAGE_CREATE_INCIDENT,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
